import React from 'react';

// @ts-ignore
import { tracking } from '@iwoca/frontend-tracking-library';
import _ from 'lodash';
import { FormGroup, Col } from 'react-bootstrap';
import { WrappedComponentProps, injectIntl } from 'react-intl';

import styles from './LimitedCompanyPerson.module.css';
import DateOfBirth from '../../../components/DateOfBirth';
import FormField from '../../../components/FormField';
import FullName from '../../../components/FullName';
import PrivacyPolicyAgreement from '../../../components/PrivacyPolicyAgreement';
import { residentialOptions } from '../constants';
import messages from '../PersonalInformation.messages';
import { renderPhones } from '../renderHelpers/renderPhones';
import { Person as TPerson } from '../types/PersonalInformation.types';

type LimitedCompanyPersonProps = {
    person: TPerson;
    onMonthSelect: (month: string) => void;
    isShareholderError: boolean;
    onStatusSelect: (status: string) => void;
    isInIndicativeOfferFlow: boolean;
    renderAddresses: (person: TPerson) => React.ReactNode;
} & WrappedComponentProps;

const LimitedCompanyPerson = ({
    person,
    onMonthSelect,
    onStatusSelect,
    intl,
    isInIndicativeOfferFlow,
    renderAddresses
}: LimitedCompanyPersonProps) => {
    const { phone, addresses, privacy_policy_agreement_date, roles } = person;

    /**
     * TODO: to be reviewed after the split testing
     */
    const onTick = (e: React.ChangeEvent<HTMLInputElement>) => {
        let customerRoles = roles.value.filter(
            (role: string) => role !== 'guarantor'
        );
        let date = null;

        const checked = e.target.checked;

        if (checked) {
            customerRoles = roles.value.concat('guarantor');
            date = new Date().toISOString();
        }

        roles.onChange?.(_.uniq(customerRoles));
        privacy_policy_agreement_date?.onChange?.(date);

        tracking.ampli.formFieldCompleted({
            form_field: 'privacy_policy'
        });
    };

    const renderAddressAndPhones = () => {
        const residentialStatus = addresses[0].residential_status;

        if (isInIndicativeOfferFlow) {
            // @indicative-offer-flow-design-001
            // This markup change works because of the markup change also happening
            // in @indicative-offer-flow-design-002, related to removing extra phone number input
            return (
                <FormGroup>
                    <Col xs={12} sm={6}>
                        {renderAddresses(person)}
                    </Col>
                    {renderPhones(phone)}
                </FormGroup>
            );
        }

        return (
            <React.Fragment>
                <FormGroup className={styles.residentialStatus}>
                    <Col xs={12} sm={6}>
                        {renderAddresses(person)}
                    </Col>
                    <FormField
                        field={residentialStatus}
                        label="Residential status">
                        <FormField.Select
                            className="residential-status-select"
                            options={residentialOptions}
                            onChange={onStatusSelect}
                            value={residentialStatus.value}
                            placeholder={intl.formatMessage({
                                ...messages.residentialStatus
                            })}
                        />
                    </FormField>
                </FormGroup>
                {renderPhones(phone)}
            </React.Fragment>
        );
    };

    return (
        <div>
            <FormGroup>
                <FullName person={person} enableDirectorSearch={true} />
                <DateOfBirth
                    // @ts-expect-error
                    dob={person.date_of_birth}
                    handleMonthSelectChange={onMonthSelect}
                />
            </FormGroup>
            {renderAddressAndPhones()}
            <FormGroup>
                <PrivacyPolicyAgreement
                    field={person.privacy_policy_agreement_date}
                    onTick={onTick}
                />
            </FormGroup>
        </div>
    );
};

export default injectIntl(LimitedCompanyPerson);
